import { render, staticRenderFns } from "./TravelPackageComponent.vue?vue&type=template&id=51f24340&scoped=true"
import script from "./TravelPackageComponent.vue?vue&type=script&lang=js"
export * from "./TravelPackageComponent.vue?vue&type=script&lang=js"
import style0 from "./TravelPackageComponent.vue?vue&type=style&index=0&id=51f24340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f24340",
  null
  
)

export default component.exports